<template>
	<div class="icon-btn-group clearfix">
		<div :class="{'icon-btn':true,'icon-btn-disabled':item.disabled, 'icon-btn-loading': item.loading}" v-for="(item, index) in dataSource"
			 @click="click(item)" :key="index" v-if="!item.hide">
			<i :class="['iconfont',item.icon]">
			</i>
			<div>{{item.text}}
				<Icon type="load-c" class="ivu-load-loop wms-ml2" v-show="item.loading"></Icon>
			</div>
		</div>
		<Dropdown v-if="dropDownMenu.length !== 0" @on-click="menuClick">
			<div class="icon-btn">
				<i class="iconfont icon-More">
				</i>
				<div>更多</div>
			</div>
			<Dropdown-menu slot="list">
				<Dropdown-item v-for="(item,index) in dropDownMenu" :disabled="item.disabled||item.loading"  v-if="!item.hide" :name="item.text" :key="index">
					<div>
						<Icon type="load-c" class="ivu-load-loop wms-ml2" v-show="item.loading"></Icon>
						{{item.text}}
					</div>
				</Dropdown-item>
			</Dropdown-menu>
		</Dropdown>
		<Dropdown class="float-right" v-if="newColumnDefs.length !== 0" transfer>
			<div class="icon-btn">
				<i class="iconfont icon-screen"></i>
				<div class="wms-mt5">筛选</div>
			</div>
			<Dropdown-menu slot="list">
				<div class="wms-plr10" v-for="(item, index) in cols" :key="index">
					<Checkbox v-if="!item.children || !item.children.length" v-model="item.show" @on-change="fieldChange">{{item.headerName}}</Checkbox>
					<strong v-else> {{item.headerName}}</strong>
					<div class="wms-pl20" v-if="!!item.children && item.children.length">
						<Checkbox v-for="(cl, ci) in item.children" :key="ci" v-model="cl.show" @on-change="fieldChange">{{cl.headerName}}</Checkbox>
					</div>
				</div>
			</Dropdown-menu>
		</Dropdown>
	</div>
</template>
<script>
import store from 'storejs'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import  {sentBossService} from '../../../utils/utils'

export default {
    name: 'iconBtnGroup',
	beforeMount() {
        //	默认隐藏的列， 插入到storage里面
        let columnKey = this.columnKey || ''
        let path = this.$router.currentRoute.path + columnKey
        let localPathData = store.get(path)
		let hideColumns = []
		if (!localPathData) {
		    //	第一次生成storage时， 默认隐藏的列插入到storage里
            this.columnDefs.forEach(item => {
                if (item.hasOwnProperty('hide') && item.hide) {
                    hideColumns.push(item.field)
                }
            })
            localPathData = localPathData || {}
            localPathData = {...localPathData, hideColumns}
            store.set(path, localPathData)
		}
	},
    props: {
        dataSource: {
            type: Array,
            default: function() {
                return []
            }
        },
        // 更多下拉
        dropDownMenu: {
            type: Array,
            default: function() {
                return []
            }
        },
        // 表格中所有列
        columnDefs: {
            type: Array,
            default: function() {
                return []
            }
        },
        // 过滤掉的列 不需要在下拉中显示
        filterCols: {
            type: Array,
            default: function() {
                return ['operate', 'selection', 'index']
            }
        },
        columnKey: {
            type: String
        }

    },
    computed: {
        newColumnDefs() {
            return this.columnDefs.filter(item => {
                if (_.isFunction(item.isDelete)) {
                    return !item.isDelete()
                } else {
                    return !item.isDelete
                }
            })
        },
        cols() {
            let columnKey = this.columnKey || ''
            let path = this.$router.currentRoute.path + columnKey
            let localPathData = store.get(path)
            if (!localPathData || !localPathData.hideColumns) {
                localPathData = {}
            }
            return this.newColumnDefs.filter((item) => {
                let hideColumns = localPathData.hideColumns || []
                if (hideColumns.indexOf(item.field) !== -1) {
                    //	如果缓存了隐藏页， 从缓存读取显示状态
                    item.hide = true
                } else {
                    // 初始值在beforeMount 里设置了， 这里不在处理
                    // if(item.hasOwnProperty('hide')) {
                    //     //	否则判断是否有初始值， 如果有读取初始值，没有的话设为显示
                    //     if (_.isFunction(item.hide)) {
                    //         item.hide = item.hide()
                    //     }
                    // } else {
                    //     item.hide = false
                    // }
                    item.hide = false
                }
                item.show = !item.hide
                //	子集
                if (item.children && item.children.length) {
                    item.children.forEach(cl => {

                        if (hideColumns.indexOf(cl.field) !== -1) {
                            //	如果缓存了隐藏页， 从缓存读取显示状态
                            cl.hide = true
                        } else {
                            //	否则判断是否有初始值， 如果有读取初始值，没有的话显示
                            if(cl.hasOwnProperty('hide')) {
                                if (_.isFunction(cl.hide)) {
                                    cl.hide = cl.hide()
                                }
                            } else {
                                cl.hide = false
                            }
                        }
                        cl.show = !cl.hide
                    })
                }
                return this.filterCols.indexOf(item.field) < 0
            })
        },
	    ...mapGetters([
		    'userName',
		    'userId'
	    ])
    },
    methods: {
        async click(item) {
            if (item.disabled) {
                return
            }
            if (item.loading === true) {
                return this.$Notice.warning({desc: '操作正在进行中，请稍等'})
            }
	        sentBossService(this, item.text)
            this.execFn(item)
            this.$emit('on-click', item)
        },
        async execFn(item) {
            if (_.isFunction(item.clickHandler)) {
                let res = item.clickHandler()
                if (res instanceof Promise) {

                    item.loading = true
                    this.$forceUpdate()
                    await res
                    item.loading = false
                    this.$forceUpdate()
                }

            }
        },
        menuClick(params) {
            let items = this.dropDownMenu.filter(function(item) {
                return item.text === params
            })
            if (items[0].loading === true) {
                return
            }
            this.execFn(items[0])
            this.$emit('on-click', items[0])
        },
        fieldChange() {
            try {
                let hideColumns = []
                for (let i = 0, l = this.cols.length; i < l; i++) {
                    let item = this.cols[i]
                    !item.show && hideColumns.push(item.field)
                    if (item.children && item.children.length) {
                        item.children.forEach(cl => {
                            !cl.show && hideColumns.push(cl.field)
                        })
                    }
                }
                let columnKey = this.columnKey || ''
                let path = this.$router.currentRoute.path + columnKey
                let localPathData = store.get(path)
                localPathData = localPathData || {}
                localPathData = {...localPathData, hideColumns}
                store.set(path, localPathData)
            }
            catch (e) {
                console.log('e', e)
            }
            let colDefs = this.newColumnDefs.map((item) => {
                item.hide = !item.show
                delete item.show
                if (item.children && item.children.length) {
                    item.children.forEach(cl => {
                        cl.hide = !cl.show
                        delete cl.show
                    })
                }
                return item
            })

            this.$emit('col-change', colDefs)
        }
    }
}
</script>
<style lang="less">
	@import "../../../styles/iview/custom.less";
	.icon-btn-group {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		.icon-btn {
			position: relative;
			padding: 0 20px;
			display: inline-block;
			text-align: center;
			cursor: pointer;
			color: @font-dark;
			font-size: 12px;
			&:hover {
				color: @main-blue
			}
			&:after {
				content: '';
				display: inline-block;
				width: 0;
				height: 30px;
				border-right: 1px solid @assist-light-steel-blue;
				position: absolute;
				right: 0;
				top: 9px;
			}
			.iconfont {
				font-size: 20px;
			}
			&:last-child:after {
				border-right: 0px solid @assist-light-steel-blue;
			}
			&.icon-btn-disabled {
				color: @font-light;
				cursor: not-allowed;
			}
			&.icon-btn-loading {
				color: @font-light;
				cursor: default;
			}
		}
	}
</style>
